export enum GamErrorInfoSize {
  SMALL = 'small',
  MEDIUM = 'medium',
  LARGE = 'large',
}
